import { render, staticRenderFns } from "./advert_space_list.vue?vue&type=template&id=2e2080ba"
import script from "./advert_space_list.vue?vue&type=script&lang=js"
export * from "./advert_space_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports